import { render, staticRenderFns } from "./edit-invoice.vue?vue&type=template&id=5b8b5302&scoped=true&"
import script from "./edit-invoice.vue?vue&type=script&lang=js&"
export * from "./edit-invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8b5302",
  null
  
)

export default component.exports